import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from 'ngx-alerts';
import {DashboardService} from '../../../../services/dashboard.service';
import {ActivatedRoute, Router} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {NgxSpinnerService} from 'ngx-spinner';
import {Observable} from 'rxjs';
import 'rxjs-compat/add/observable/interval';

@Component({
    selector: 'app-trips-map',
    templateUrl: './trips-map.component.html',
    styleUrls: ['./trips-map.component.scss']
})
export class TripsMapComponent implements OnInit, OnDestroy {

    // markers = [{lat:24.799045,long:120.977245}];
    public origin: any;
    public destination: any;

    tripId = '';
    tripParams = {
        isBasic: true,
        isVHSReport: false
    };

    tripBasicDetails = undefined;
    tripLatLongs: any[] = [];
    public flightPlanCoordinates: any[] = [];
    drivingAlerts: any[] = [];

    isOnGoingTrip = undefined;
    vehicleAlerts: any[] = [];
    sub: any;
    liveLocationDetails: any;

    constructor(private alertService: AlertService, private dashboardService: DashboardService, private route: ActivatedRoute,
                private router: Router, private spinner: NgxSpinnerService,) {
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.tripId = this.route.snapshot.params.tripId;
        if (!this.tripId) {
            this.router.navigate(['../../'], {relativeTo: this.route});
            return;
        }

        this.getTripDetails(this.tripId);
        // this.getTripLatlongs(this.tripId);
        this.getTripDrivingAlerts(this.tripId);
        this.getTripVehicleAlerts(this.tripId);
    }


    private getTripDetails(tripId: string) {
        if (!this.sub) {
            this.spinner.show();
        }
        this.dashboardService.getTripDetailsById(tripId, this.tripParams).pipe(finalize(() => this.spinner.hide())).subscribe(
            (res: any) => {
                this.tripBasicDetails = res.basicTripsData[0];
                console.log(this.tripBasicDetails)
                this.origin = {lat: +this.tripBasicDetails.startLat, lng: +this.tripBasicDetails.startLong};
                this.destination = {lat: +this.tripBasicDetails.endLat, lng: +this.tripBasicDetails.endLong};
                if (this.tripBasicDetails.endLat) {
                    this.isOnGoingTrip = false;
                } else {
                    this.isOnGoingTrip = true;
                    if (!this.sub) {
                        this.sub = Observable.interval(120000)
                            .subscribe((val) => {
                                this.getTripDetails(tripId);
                            });
                    }
                }
                this.getTripLatlongs(tripId);
            }, error1 => {
                console.error(error1);
                this.alertService.danger(error1.message ? error1.message : error1);
            }
        );
    }

    getTripDuration() {
        let date = new Date(this.tripBasicDetails.startDate).getTime();
        let date2 = new Date(this.tripBasicDetails.endDate).getTime();
        let hourDiff = date2 - date; //in ms
        let secDiff = hourDiff / 1000; //in s
        let minDiff = hourDiff / 60 / 1000; //in minutes
        let hDiff = hourDiff / 3600 / 1000; //in hours
        let humanReadable = {};
        humanReadable['hours'] = Math.floor(hDiff);
        humanReadable['minutes'] = Math.round(minDiff - 60 * humanReadable['hours']);
        return humanReadable;
    }

    private getTripLatlongs(tripId: string) {
        this.spinner.show();
        this.dashboardService.getTripLatlongs(tripId).pipe(finalize(() => this.spinner.hide())).subscribe(
            (res: any) => {
                let data: any[] = res.data;
                data.push({location: {lat: this.origin.lat, lng: this.origin.lng}});
                data.push({location: {lat: this.destination.lat, lng: this.destination.lng}});
                if (data && data.length > 0) {
                    data.forEach(d => this.tripLatLongs.push({location: {lat: +d.latitude, lng: +d.longitude,createdOn:d.createdOn}}));
                }

                // this.initMap();
                this.flightPlanCoordinates = [];
                this.tripLatLongs.forEach(tl => {
                    if (tl.location.lat && tl.location.lng) {
                        this.flightPlanCoordinates.push({lat: tl.location.lat, lng: tl.location.lng, createdOn: tl.location.createdOn});
                    }
                });
                console.log(this.isOnGoingTrip);
                if (this.isOnGoingTrip) {
                    if (this.flightPlanCoordinates && this.flightPlanCoordinates.length) {
                        console.log(this.flightPlanCoordinates[this.flightPlanCoordinates.length - 1]);
                        this.liveLocationDetails = {
                            lat: this.flightPlanCoordinates[this.flightPlanCoordinates.length - 1].lat,
                            lng: this.flightPlanCoordinates[this.flightPlanCoordinates.length - 1].lng,
                            createdOn: this.flightPlanCoordinates[this.flightPlanCoordinates.length - 1].createdOn
                        };
                        console.log(this.liveLocationDetails)
                        this.getLiveLocationDetails(this.liveLocationDetails.lat, this.liveLocationDetails.lng);
                    }
                }
            }, error1 => {
                console.error(error1);
                this.alertService.danger(error1.message ? error1.message : error1);
            }
        );
    }

    // initMap(): void {
    //   const map = new google.maps.Map(
    //     document.getElementById('map') as HTMLElement,
    //     {
    //       zoom: 12,
    //       center: {lat: this.origin.lat, lng: this.origin.lng},
    //       mapTypeId: 'terrain',
    //     }
    //   );
    //   let flightPlanCoordinates = [];
    //   this.tripLatLongs.forEach(tl => {
    //     if (tl.location.lat && tl.location.lng) {
    //       flightPlanCoordinates.push({lat: tl.location.lat, lng: tl.location.lng});
    //     }
    //   });
    //
    //   const flightPath = new google.maps.Polyline({
    //     path: flightPlanCoordinates,
    //     geodesic: true,
    //     strokeColor: '#FF0000',
    //     strokeOpacity: 1.0,
    //     strokeWeight: 2,
    //   });
    //
    //   flightPath.setMap(map);
    // }
    private getTripDrivingAlerts(tripId: string) {
        this.dashboardService.getTripDrivingAlerts(tripId).subscribe(
            (res: any) => {
                if (res.drivingAlerts && res.drivingAlerts.length) {
                    res.drivingAlerts.forEach(da => {
                        let alert = JSON.parse(da.data);
                        let name = alert.alert_Type.split(' ').map(a => a.charAt(0).toUpperCase()).join('');
                        alert['label'] = name;
                        this.drivingAlerts.push(alert);
                    });
                }
            }, error1 => {
                console.error(error1);
                this.alertService.danger(error1.message ? error1.message : error1);
            }
        );
    }

    private getTripVehicleAlerts(tripId: string) {
        this.dashboardService.getTripVehicleAlerts(tripId).subscribe(
            (res: any) => {
                this.vehicleAlerts = res.alerts;
            }, error1 => {
                console.error(error1);
                this.alertService.danger(error1.message ? error1.message : error1);
            }
        );
    }

    getLiveLocationDetails(ltd, lng) {
        this.dashboardService.getLocationDetails(ltd, lng).subscribe(
            (res: any) => {
                this.liveLocationDetails.locationDetails = res.locationDetails.locationDetails;
            }, error => {
                console.error(error);
                this.alertService.danger(error.message ? error.message : error);
            }
        );
    }
}
